import { STORE_BUNDLE_ASSETS_GET_SUCCESS, STORE_BUNDLE_ASSETS_GET_FAILURE } from '../actions/types';

const initialState = {
  defaults: {
    isLoaded: false,
    isLoading: false,
    assets: [],
  },
};

export default (state = initialState, action) => {
  const namespace = action?.options?.namespace || action?.context?.options?.namespace || 'default';
  const { defaults } = state;
  const { [namespace]: namespaceState = defaults } = state;

  switch (action.type) {
    case STORE_BUNDLE_ASSETS_GET_SUCCESS: {
      const { response = {} } = action.payload;
      return {
        ...state,
        [`namespace-${namespace}`]: {
          ...namespaceState,
          assets: response[0]?.assets || {},
          isLoading: false,
          isLoaded: true,
        },
      };
    }
    case STORE_BUNDLE_ASSETS_GET_FAILURE: {
      return {
        ...state,
        [`namespace-${namespace}`]: {
          ...namespaceState,
          assets: [],
          isLoading: false,
          isLoaded: true,
        },
      };
    }
    default: {
      const { options = {} } = action;
      if (options.success === STORE_BUNDLE_ASSETS_GET_SUCCESS) {
        return {
          ...state,
          [`namespace-${namespace}`]: {
            ...namespaceState,
            isLoading: true,
          },
        };
      }

      return state;
    }
  }
};
